(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('DayTranslationService', DayTranslationService);

  /** @ngInject */
  function DayTranslationService($translate) {
    var service = {
      translateDayNumber: translateDayNumber
    };

    return service;

    function translateDayNumber(dayNumber) {
      switch (dayNumber) {
        case 0:
          return $translate.instant('MON');
        case 1:
          return $translate.instant('TUE');
        case 2:
          return $translate.instant('WED');
        case 3:
          return $translate.instant('THU');
        case 4:
          return $translate.instant('FRI');
        case 5:
          return $translate.instant('SAT');
        case 6:
          return $translate.instant('SUN');
        default:
          return dayNumber;
      }
    }
  }
})();
